<template>
  <div class="form-nested-accordion">
    <div v-if="!this.frmAlterarDados.cnpj.value == 'Sem Permissão' || !this.frmAlterarDados.cnpj.value == ''">
      <div class="row">
        <div class="col-md-6">
          <FormHelper
            :inputVar="frmAlterarDados.cnpj"
            :form="frmAlterarDados"
            label="CNPJ"
            mask="##.###.###/####-##"
            validationType="cnpj"
            disabled="disabled"
          ></FormHelper>
        </div>
        <div class="col-md-6">
          <FormHelper
            :inputVar="frmAlterarDados.senhaatual"
            :form="frmAlterarDados"
            label="Senha Atual"
            type="password"
            validationType="local"
          ></FormHelper>
        </div>
      </div>
      <div class="row">
        <form @submit.prevent="updateEmail" action="#" method="get">
          <div class="col-md-10">
            <FormHelper
              :inputVar="frmAlterarDados.email"
              :form="frmAlterarDados"              
              label="Email"
              validationType="email"
            ></FormHelper>
          </div>
          <div class="col-md-2 col-only-button">
            <button aria-label="Alterar" class="btn primary-button stretch">Alterar Email</button>
          </div>
        </form>
      </div>      
      <div class="alert alert-warning">
        <span>A senha deve possuir no mínimo: <b>8 caracteres, letras maiúsculas, minúsculas e números</b></span>          
      </div>          

      <div class="row" v-if="this.frmAlterarDados.cnpj.value != 'Sem Permissão'">
        <form @submit.prevent="updateSenha" action="#" method="get">
          <div class="col-md-5">
            <FormHelper
              :inputVar="frmAlterarDados.senha"
              :form="frmAlterarDados"
              label="Nova senha"
              placeholder="*******"
              maxlength="15"
              type="password"
              validationType="password"
            ></FormHelper>
          </div>          
          <div class="col-md-5">
            <FormHelper
              :inputVar="frmAlterarDados.senhaconfirm"
              :form="frmAlterarDados"
              label="Confirmar senha"
              maxlength="15"
              placeholder="*******"
              validationType="comparison"
              :compareTo="frmAlterarDados.senha"
              type="password"
            ></FormHelper>
          </div>
          <div class="col-md-2 col-only-button">
            <button aria-label="Alterar" class="btn primary-button stretch">Alterar Senha</button>
          </div>
        </form>
      </div>
    </div>
    <div v-else>
      <span v-if="this.frmAlterarDados.cnpj.value == 'Sem Permissão' || this.frmAlterarDados.cnpj.value == ''"
    style="margin-left: 2%; width:95%;" class="alert alert-danger font-size-0_8em">
      A senha só pode ser alterada logando com o CNPJ.
    </span>
    </div>
  </div>
</template>
<script>
import FormHelper from "../FormHelper.vue";

export default {
  name: "UpdatePasswordEmail",
  components: {
    FormHelper
  },
  props: {
    msg: String
  },
  data() {
    return {
      frmAlterarDados: {
        attemptSubmit: false,
        cnpj: new this.formInput(true, "00.000.000/0000-00"),
        senhaatual: new this.formInput(),
        email: new this.formInput(false),
        senha: new this.formInput(false),
        senhaconfirm: new this.formInput(false)
      }
    };
  },
  mounted(){
    $.ajax({
      url: this.$apiUrl + "Cliente.svc/getcnpj",
      dataType: "json",
      type: "GET",
      xhrFields: { withCredentials: true },
      success: data => {    
        //// console.log(data)
        this.frmAlterarDados.cnpj.value = data;
      }
    });
    $.ajax({
      url: this.$apiUrl + "Cliente.svc/getemail",
      dataType: "json",
      type: "GET",
      xhrFields: { withCredentials: true },
      success: data => {    
        //// console.log(data)
        this.frmAlterarDados.email.value = data;
      }
    });
  },
  computed: {
    formErrors: function () {
      const errors = Object.keys(this.frmAlterarDados).filter((key) => this.frmAlterarDados[key].validation && !this.frmAlterarDados[key].validation.status)
      return errors.length;
    }
  },
  watch: {
    "frmAlterarDados.senhaatual.value": function(val) {
      if (val == "") {
        this.frmAlterarDados.senhaatual.validation.status = false;
        this.frmAlterarDados.senhaatual.validation.message =
          "Por favor, preencha o campo acima";
      } else {
        this.frmAlterarDados.senhaatual.validation.status = true;
        this.frmAlterarDados.senhaatual.validation.message = "";
      }
    },
    "frmAlterarDados.senha.value": function(val) {

     if (val.length < 6) {
        this.frmAlterarDados.senha.validation.status = false       
        this.frmAlterarDados.senha.validation.message =
          "Minimo"
        this.frmAlterarDados.attemptSubmit = true;
      }
      else if (val !== this.frmAlterarDados.senhaconfirm.value)
      {
        this.frmAlterarDados.senhaconfirm.validation.status = false
      }
      else {
        this.frmAlterarDados.senha.validation.status = true
        this.frmAlterarDados.senhaconfirm.validation.status = true
      }
    },
    "frmAlterarDados.senhaconfirm.value": function(val) {
      if (val === this.frmAlterarDados.senha.value)
      {
        this.frmAlterarDados.senhaconfirm.validation.status = true
      }
      else
      {
        this.frmAlterarDados.senhaconfirm.validation.status = false
      }
    }
  },
  methods: {
    buildError: function (msg) {
        // Escreve o erro no formato padrão e retorna
        return { status: false, message: msg }
    },
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : "";

      this.validation = {
        // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !(this.required && this.value === ""),
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    },
    updateEmail: function() {
      //Validações manuais dos campos devido form fugir do modelo padrao
      this.frmAlterarDados.senha.validation.status = true;
      this.frmAlterarDados.attemptSubmit = true;

      if(this.formErrors === 0){        
        let obj = {};
        obj.email = this.frmAlterarDados.email.value;
        obj.senhaAtual = this.frmAlterarDados.senhaatual.value;

        //Colocar codigo ajax aqui
        var xhr = new XMLHttpRequest();
        xhr.onload = () => {
          if (xhr.status == 200) {
            swal({
              title: "Email alterado com sucesso",
              icon: "success"
            }).then(() => (location.href = window.location.href))       
          }
          else if (xhr.status == 412)
          {
            swal({
              title: "Informe um email para realizar a alteração.",
              icon: "warning"
            })
          } 
          else
          {
            swal({
              title: "Erro ao alterar o email",
              icon: "error"
            })
          }
        }
        xhr.open("POST", this.$apiUrl + "Cliente.svc/alteraremail");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.withCredentials = true;
        xhr.send(JSON.stringify( obj ));

        // console.log("update-email");
      }
    },
    updateSenha: function() {
    //Validações manuais dos campos devido form fugir do modelo padrao
      this.frmAlterarDados.email.validation.status = true;   
      this.frmAlterarDados.attemptSubmit = true;   
            
      if(this.formErrors === 0){      
        let obj = {};
        obj.novaSenha = this.frmAlterarDados.senha.value;
        obj.senhaAtual = this.frmAlterarDados.senhaatual.value;

        //Colocar codigo ajax aqui
        var xhr = new XMLHttpRequest();
        xhr.onload = () => {
          if (xhr.status == 200) {
            swal({
              title: "Senha alterada com sucesso",
              icon: "success"
            }).then(() => (location.href = window.location.href))
          }
          else if (xhr.status == 400) {
            swal({
              title: "Senha atual não confere",
              icon: "error"
            })
          } 
          else if (xhr.status == 401) {
            swal({
              title: "A nova senha não pode ser igual a atual",
              icon: "error"
            })
          } 
          else
          {
            swal({
              title: "Erro ao alterar a senha",
              icon: "error"
            })
          }
        }
        xhr.open("POST", this.$apiUrl + "Cliente.svc/alterarsenha");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.withCredentials = true;
        xhr.send(JSON.stringify( obj ));

        // console.log("senha");
      }
    }
  }
};
</script>
